import React, { useContext } from 'react';
import { compact } from 'lodash';

import Chapter from '../../Chapter';
import ChapterPlayerContext from '../../ChapterPlayer.context';
import { AssetType } from '../../../../utils/storage';

import Carousel, {
    CarouselProps,
    calculateDuration,
    calculateExitDuration,
} from './screens/Carousel';

import './styles/fonts.scss';


type CarouselViewProps = {
    data: CarouselProps,
    languages: string[],
};

function CarouselView({ data, languages }: CarouselViewProps) {
    const {
        width,
        height,
    } = useContext(ChapterPlayerContext);

    const resolvedLanguages = data.languages?.length
        ? data.languages
        : (languages?.length ? languages : ['EN']);

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                ['--rise-font-vertical-correction' as string]: '1',
            }}
        >
            <Carousel
                {...data}
                width={width}
                height={height}
                languages={resolvedLanguages}
            />
        </div>
    );
}

export default class CarouselChapter extends Chapter<CarouselProps> {
    component = () => (
        <CarouselView
            data={this.data}
            languages={this.languages}
        />
    )

    fonts = [
        'NTSuperExtended',
        'HelveticaNowDisplay',
    ]

    calculateDuration() {
        const data = this.getChapterData();

        return (calculateDuration(data) - calculateExitDuration(data)) / 1000;
    }

    getAssetsToCache(): AssetType[] {
        return compact((this.data.list || []).map(item => item?.media))
            .filter(media => media.url);
    }

    private getChapterData(): CarouselProps {
        const languages = this.data.languages?.length
            ? this.data.languages
            : (this.languages?.length ? this.languages : ['EN']);

        return {
            ...this.data,
            languages,
        };
    }
}
